// =============================================================================
// app.ts — Punto de entrada TypeScript del pipeline esbuild
// =============================================================================

// -----------------------------------------------------------------------------
// 1. Bootstrap JS (bundle ESM: incluye Popper.js automáticamente vía
//    dependencia @popperjs/core; esbuild aplica tree-shaking a nivel de módulo)
// -----------------------------------------------------------------------------
import 'bootstrap';

// -----------------------------------------------------------------------------
// 2. Axios — cliente HTTP para la API
// -----------------------------------------------------------------------------
import axios from 'axios';

// Configurar CSRF de Django en las peticiones axios
axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = 'X-CSRFToken';

// Exponer axios globalmente para uso desde scripts inline
window.axios = axios;

// -----------------------------------------------------------------------------
// 3. Módulos TypeScript de la aplicación
// -----------------------------------------------------------------------------
import './modules/example';
